import { render, staticRenderFns } from "./EzuiFullPlayer.vue?vue&type=template&id=c07a05e8&scoped=true"
import script from "./EzuiFullPlayer.vue?vue&type=script&lang=js"
export * from "./EzuiFullPlayer.vue?vue&type=script&lang=js"
import style0 from "./EzuiFullPlayer.vue?vue&type=style&index=0&id=c07a05e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07a05e8",
  null
  
)

export default component.exports